<i18n>
{
"en": {
  "ATTACHEMENT": "Attachement",
  "WRITEAMESSAGE": "Write a Message",
  "COMPOSEMESSAGE": "Compose Message",
  "SELECTRECIPIENT": "Select Recipient",
  "SELECTBUSROUTE": "Select Bus Route",
  "RECIPIENT0": "All Parents",
  "RECIPIENT1": "All Bus Monitors",
  "RECIPIENT2": "Parents in Same Grade",
  "RECIPIENT3": "Parents in Same Bus",
  "RECIPIENT4": "Parents with Children Physically Present on Same Bus",
  "RECIPIENT5": "Parents with Children Physically not Present on Same Bus",
  "RECIPIENT6": "Specific Person: Student's Relative or Bus Monitor",
  "SEARCHPERSONNAME": "Search person's name",
  "CONVERSATION": "Conversation",
  "WRITEYOURMESSAGE": "Write your message",
  "MESSAGEFOR": "Message For",
  "CHARACTERSREMAINING": "Characters Remaining:",
  "SELECTGRADE": "Select Grade",
  "SELECTCLASS": "Select Class",
  "SELECTBUS": "Select Bus",
  "BUSSUPERVISOR": "Bus Supervisor",
  "PRIMARY": "Primary",
  "NOT": "Not",
  "LISTALLSTUDENTS": "List All Students",
  "ATTACHMENT": "Attachment",
  "FILESWITHASIZE": "Files with a size less than 400kb",
  "MONITOR": "Monitor",
  "FATHER": "Father",
  "MOTHER": "Mother",
  "GUARDIAN": "Guardian",  
  "CANCEL": "Cancel",
  "SENDING": "Sending...",
  "SEND": "Send",
  "THISTRIPNOLONGEREXIST": "This trip no longer exist!",
  "NOSTUDENTSMARKEDMISSING": "None of the students marked as missing!",
  "EMAILHASSENT": "Email has been sent!",
  "EMAILHASNOTSEND": "Email has not send!",
  "SUCCESS": "Message has been sent!",
  "FAILED": "Failed to send!",
  "NOGRADESTUDENTS": "There are no students in this grade!",
  "ERROR": "Error",
  "CLOSE": "Close",
  "FILEISTOOLARGERMAXFILEIS": "File is too large, max file is {len}.",
  "TYPEERROR": "File extensions should be {len}.",
  "ATTACHING": "Attaching..."
},
"ar": {
 "ATTACHEMENT": "مرفقات",
  "WRITEAMESSAGE": "اكتب رسالة",
  "COMPOSEMESSAGE": "إنشاء رسالة",
  "SELECTRECIPIENT": "اختر المرسل إليه",
  "SELECTBUSROUTE": "اختر خط السير",
  "RECIPIENT0": "جميع الآباء والأمهات",
  "RECIPIENT1": "جميع المشرفات",
  "RECIPIENT2": "الآباء في نفس الصف",
  "RECIPIENT3": "الآباء في نفس الحافلة",
  "RECIPIENT4": "أباء الطلاب الموجودين على نفس الحافلة",
  "RECIPIENT5": " أباء الطلاب الغير الموجودين على نفس الحافلة",
  "RECIPIENT6": "شخص محدد: ولي امر الطالب أو المشرفة",
  "SEARCHPERSONNAME": "ابحث عن اسم الشخص",
  "CONVERSATION":" محادثة",
  "WRITEYOURMESSAGE": " اكتب رسالتك",
  "MESSAGEFOR": " رسالة ل",
  "CHARACTERSREMAINING": " الحروف المتبقية",
  "SELECTGRADE": "حدد الدرجة",
  "SELECTCLASS": "حدد الصف",
  "SELECTBUS": " حدد الحافلة",
  "BUSSUPERVISOR": "المشرفات",
  "PRIMARY": "الأساسي",
  "NOT": "ليس",
  "LISTALLSTUDENTS": " قائمة جميع الطلاب",
  "ATTACHMENT": "المرفق",
  "FILESWITHASIZE": " الملفات ذات الحجم أقل من 400 كيلوبايت",
  "FILESWITHASIZE1": " الملفات بحجم أقل من",
  "MONITOR": "المشرفة",  
  "FATHER": "الاب",
  "MOTHER": "الام",
  "GUARDIAN": "ولي الامر",  
  "CANCEL": "إلغاء",
  "SENDING": "إرسال",
  "SEND": "ارسل",
  "THISTRIPNOLONGEREXIST": "لم تعد هذه الرحلة موجودة!",
  "NOSTUDENTSMARKEDMISSING":"لا يوجد طلاب مفقودين!",
  "EMAILHASSENT": "تم ارسال البريد الالكتروني!",
  "EMAILHASNOTSEND": "لم يرسل البريد الإلكتروني!",
  "SUCCESS": "تم ارسال الرسالة!",
  "FAILED": "فشل فى الارسال!",
  "NOGRADESTUDENTS": "لا يوجد طلاب في هذا الصف!",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "FILEISTOOLARGERMAXFILEIS": "ملحقات الملفات يجب أن تكون {len}.",
  "TYPEERROR": "ملحقات الملفات يجب أن تكون {len}.",
  "ATTACHING": "تعلق..."
}
}
</i18n>
<template>
    <el-dialog id="messageDialog" size="small" :show-close="false" @close="clearCompose" :title="$t('COMPOSEMESSAGE')" :visible.sync="messageBox">
      <el-form>
        <div v-if="!message && showRemove">
          <el-form-item :label="$t('SELECTRECIPIENT')">
            <el-select @change="compose.RecipientID=''"  v-model="compose.Recipient" :placeholder="$t('SELECTRECIPIENT')">
                <el-option value="0" :label="$t('RECIPIENT0')"></el-option>
                <el-option value="1" :label="$t('RECIPIENT1')"></el-option>
                <el-option value="2" :label="$t('RECIPIENT2')"></el-option>
                <el-option value="3" :label="$t('RECIPIENT3')"></el-option>
                <el-option value="4" :label="$t('RECIPIENT4')"></el-option>
                <el-option value="5" :label="$t('RECIPIENT5')"></el-option>
                <el-option value="6" :label="$t('RECIPIENT6')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="compose.Recipient==2" :label="$t('SELECTGRADE')">
            <el-select v-model="Grade" @change="classID = null" value-key="GradeID" :placeholder="$t('SELECTGRADE')" filterable>
                <el-option
                :key="key"
                v-for="(grade, key) in grades"
                :label="grade.Name"
                :value="grade">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="classes" v-if="compose.Recipient==2 && compose.RecipientID" :label="$t('SELECTCLASS')">
            <el-radio-group size="small" v-model="classID">
              <el-radio-button :key="index" v-for="(cls, index) in Grade.Classes" v-if="cls" :label="cls"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="compose.Recipient==3 && buses!=''" :label="$t('SELECTBUS')">
            <el-select v-model="compose.RecipientID" :placeholder="$t('SELECTBUS')" filterable>
                <el-option
                    :key="index" 
                    v-for="(item, index) in buses[4]"
                    :value="item.BusID"
                    :label="item.bus_number"
                    >
                    <span><i class="fa fa-bus"></i> {{item.bus_number}}-{{item.TourName}}</span>
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="(compose.Recipient==4 || compose.Recipient==5) && buses!=''" :label="$t('SELECTBUSROUTE')">
            <el-select v-model="compose.RecipientID" :placeholder="$t('SELECTBUSROUTE')" filterable @visible-change="getBoardedTrips()">
                <el-option
                    :key="index" 
                    v-for="(item, index) in buses[5]"
                    :label="item.bus_number"
                    :value="item.TripID"
                    >
                    <span><i class="fa fa-bus"></i> {{item.bus_number}}-{{item.TourName}}</span>
                </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-card class="box-card" :body-style="{display: (message || (!message && showRemove)) ? '' : 'none'}" v-show="compose.Recipient==6 && (person || message || (!message && showRemove))">
          <div slot="header" class="media" v-if="person">
                <div class="media-left">
                    <img class="media-object img-circle" style="width: 80px" :src="getAsset(person.ImagePath, (person.Relation==null || person.Relation=='' ? 'supervisor' : 'guardian'))" />
                </div>
                <div class="media-body">
                    <h4 class="media-heading">
                        {{_FullName({NameEN: person.FullName_EN, NameAR: person.FullName_AR})}}
                        <div class="pull-right" v-show="person && showRemove">
                            <i @click="clearInput" class="fa fa-2x fa-remove"></i>
                        </div><br/>
                        <br/>
                        <b>{{(person.Relation==null || person.Relation=='') ? $t('BUSSUPERVISOR') : $t(person.Relation)}}</b>
                    </h4>

                </div>
            </div>
          <div v-show="message">
            <i class="fa fa-commenting"></i> <b>{{$t('CONVERSATION')}}</b> <br /><span v-text="message.Text"></span>
          </div>
          <div v-show="!message && showRemove">
              <el-autocomplete
                      v-model="personName"
                      :fetch-suggestions="querySearch"
                      :placeholder="$t('SEARCHPERSONNAME')"
                      @select="addPerson"
                      icon="search"
              ></el-autocomplete
                      v-model="person.value">
          </div>
        </el-card>
        <el-card class="box-card" :body-style="{ padding: '0px'}" v-show="compose.Recipient==6 && students.length!=0">
            <div slot="header">{{$t('MESSAGEFOR')}}</div>
            <el-collapse-transition :key="key" v-for="(student, key) in students">
               <div class="list-group-item" v-show="showStudentsList(student.StudentID)">
                    <div class="media">
                        <div class="media-left">
                            <img class="media-object img-circle" style="width: 50px" :src="getAsset(student.ImagePath, 'student')">
                        </div>
                        <div class="media-body">
                            <h4 class="media-heading">
                                {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}
                                <div class="pull-right" v-if="students.length > 1">
                                    <el-tooltip :content="$t('LISTALLSTUDENTS')" placement="top" effect="light"><el-button style="padding-right: 8px;" @click="compose.RecipientID = null" v-show="showStudentsList(student.StudentID, true)" type="text" icon="arrow-down"></el-button></el-tooltip>
                                    <el-radio class="radio" v-model="compose.RecipientID" :label="student.StudentID"><small>{{student.IsMain!=null ? '' : $t('NOT')}} {{$t('PRIMARY')}}</small></el-radio>
                                </div>
                            </h4>
                        </div>
                    </div>
                </div>
            </el-collapse-transition>
        </el-card>
        <el-card :body-style="{ padding: '8px'}" class="compose">
          <el-input
                  slot="header"
                  type="textarea"
                  :maxlength="256"
                  :rows="8"
                  :placeholder="$t('WRITEYOURMESSAGE')"
                  v-model="compose.Text">
          </el-input>
          <el-row>
            <el-col :span="8">
              <el-upload
                      :on-success="updateFile"
                      :before-upload="beforeUpload"
                      :on-progress="limitFile"
                      :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
                      :with-credentials="true"
                      :action="URL + 'media/upload'"
                      :data="{folder: 'message', type: 'attachment'}"
                      >
                  <el-button size="small" type="warning"><i class="fa fa-paperclip"></i> {{$t('ATTACHMENT')}}</el-button>
                  <div slot="tip" class="el-upload__tip">{{$t('FILESWITHASIZE')}} </div>
              </el-upload>
            </el-col>
            <el-col v-if="attached != null" :span="10" style="float: left;"><el-tag :closable="attached" @close="handleRemove()" :type="attached ? 'success' : 'primary'"><i :class="{'el-icon-loading': !attached}"></i> {{attached ? compose.Attachment.Filename : $t('ATTACHING')}}</el-tag></el-col>
            <el-col :span="attached != null ? 6 : 16"><h5 style="margin: 0px;">{{$t('CHARACTERSREMAINING')}} <span class="text-right" v-text="textLimit()">256</span></h5></el-col>
          </el-row>
        </el-card>

      </el-form>
   <span slot="footer" class="dialog-footer">
    <el-button @click="messageBox = false">{{$t('CANCEL')}}</el-button>
    <el-button type="primary" :disabled="validateInput()" :loading="loadingSend" @click="sendMessage()">{{loadingSend ? $t('SENDING') : $t('SEND')}}</el-button>
  </span>
    <el-dialog :title="$t('ERROR')" v-model="error" size="small">
      <div class="el-alert el-alert--error">
        <i class="el-alert__icon el-icon-circle-cross is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in errorMessage" v-html="printError(messageError)"></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
      </span>
    </el-dialog>  
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import Vue from 'vue'
  import { EventBus } from '../../event-bus.js'
  import _ from 'lodash'
  export default {
    name: 'ElMessageDialog',
    componentName: 'ElMessageDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      showRemove: {
        type: Boolean,
        default: true
      },
      studentList: {
        type: Array,
        default: function () {
          return []
        }
      },
      parent: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        messageBox: false,
        compose: {Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: {Filename: null}, parentID: null, threadID: null, groupTextID: null},
        message: '',
        grades: [],
        grade: {},
        classes: [],
        buses: {4: [], 5: []},
        classID: null,
        loadingSend: false,
        person: '',
        personName: '',
        students: [],
        maxLimit: 256,
        errorMessage: null,
        error: false,
        attached: null,
        autoSource: null
      }
    },
    mounted () {
      EventBus.$on('boarding', boarding => {
        let TripID = boarding.TripID
        if (EventBus.recorded.indexOf(TripID) >= 0) return
        this.getBoardedTrips()
        EventBus.recorded.push(TripID)
      })
      EventBus.$on('trip', trip => {
        if (trip.IsClosed !== 1) return
        let index = EventBus.recorded.indexOf(trip.TripID)
        if (index < 0) return
        this.getBoardedTrips()
        this.$delete(EventBus.recorded, index)
      })
    },
    computed: {
      Grade: {
        get: function () {
          return this.grade
        },
        set: function (Grade) {
          this.grade = Grade
          this.compose.RecipientID = Grade.Name
        }
      }
    },
    watch: {
      messageBox () {
        this.updateVisible()
      },
      visible () {
        this.switchLanguage()
        this.messageBox = this.visible
        if (!this.showRemove && !_.isEmpty(this.studentList)) {
          this.compose.Recipient = 6
          if (this.studentList.length === 1) this.compose.RecipientID = this.studentList[0].StudentID
          if (_.isEmpty(parent)) this.getRelation()
          else this.person = this.parent
          this.students = this.studentList
        } else this.loadDropDownData()
      }
    },
    methods: {
      updateVisible () {
        this.$emit('update:visible', this.messageBox)
      },
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      sendMessage () {
        this.compose.ClassID = this.classID
        let postData = {message: this.compose}
        let self = this
        self.loadingSend = true
        this.$http.post('/message/send', postData).then(function (response) {
          self.loadingSend = false
          if (response.data.error && (self.compose.Recipient === '4' || self.compose.Recipient === '5')) self.getBoardedTrips()
          self.$message({
            message: self.$t(response.data.message),
            type: response.data.error ? 'error' : 'success',
            showClose: true
          })
          self.messageBox = false
        }).catch(function () {
        })
      },
      loadDropDownData () {
        let self = this
        if (!_.isEmpty(this.grades) || !_.isEmpty(this.buses[4])) return
        axios.all([this.$http.get('/configuration/grade'), this.$http.get('/bus/assigned'), this.$http.get('/bus/boarded_trips')])
          .then(axios.spread(function (grades, assigned, boarded) {
            Vue.set(self.buses, 4, assigned.data)
            Vue.set(self.buses, 5, boarded.data)
            self.grades = grades.data
          })).catch(function (response) {
            console.log(response)
          })
      },
      getBoardedTrips () {
        let self = this
        this.$http.get('/bus/boarded_trips').then(function (response) {
          if (response.data) Vue.set(self.buses, 5, response.data)
        }).catch(function (response) {})
      },
      clearInput () {
        delete this.compose.PersonID
        this.person = ''
        this.students = []
        this.compose.RecipientID = null
        this.personName = ''
      },
      clearCompose () {
        this.person = ''
        this.attached = null
        this.students = []
        this.personName = ''
        this.compose = {Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: {Filename: null}, parentID: null, threadID: null, groupTextID: null}
      },
      getMonitor (id) {
        let self = this
        this.$http.get('/supervisor/' + id + '')
          .then(function (response) {
            self.person = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      addPerson (data) {
        this.person = data.person
        this.personName = data.value
        this.compose.RecipientID = this.person.BusMonitorID
        this.students = []
        this.getStudents(this.person.PersonID)
      },
      querySearch (queryString, cb) {
        let self = this
        if (self.student === null) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findPerson(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findPerson (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/message/find?term=' + queryString + '&lang=' + localStorage.getItem('lang'), {cancelToken: this.autoSource.token})
      },
      getStudents (GuardianID) {
        let self = this
        this.$http.get('/guardian/' + GuardianID + '')
          .then(function (response) {
            if (_.isUndefined(response.data.students)) return
            self.students = response.data.students
            if (self.students.length === 1) self.compose.RecipientID = self.students[0].StudentID
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getRelation () {
        let self = this
        self.students = []
        self.person = ''
        this.$http.get('/student/relation?StudentID=' + this.student[0].StudentID)
          .then(function (response) {
            if (!_.isEmpty(response.data)) self.person = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      validateInput () {
        let AntiID = ['0', '1']
        if (this.attached !== null && !this.attached) return true
        if (this.compose.Recipient === null) return true
        if (AntiID.indexOf(this.compose.Recipient) < 0) {
          if (_.isEmpty(this.compose.RecipientID)) return true
        }
        if (_.isEmpty(this.compose.Text)) return true
        return false
      },
      textLimit () {
        if (this.compose.Text === null) return this.maxLimit
        return this.maxLimit - this.compose.Text.length
      },
      updateFile (response, file, fileList) {
        this.compose.hasAttachment = this.attached = true
        this.compose.Attachment.Filename = response.file_name
        this.compose.Attachment.type = file.raw.type
      },
      handleRemove () {
        this.attached = null
        this.compose.hasAttachment = false
        this.compose.Attachment = {}
      },
      limitFile (event, file, fileList) {
        this.attached = false
        if (fileList.length > 1) fileList.splice(0, 1)
      },
      showStudentsList (StudentID, expand = false) {
        if (expand && this.students.length === 1) return false
        if (!expand && _.isEmpty(this.compose.RecipientID)) return true
        if (this.compose.RecipientID === StudentID) return true
      },
      beforeUpload (file) {
        const isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text'
        const isLt2KB = file.size / 1024 < 400
        this.errorMessage = {}
        if (!isJPG) {
          this.errorMessage['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt'
        }
        if (!isLt2KB) {
          this.errorMessage['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB'
        }
        if (Object.keys(this.errorMessage).length !== 0) this.error = true
        return isJPG && isLt2KB
      }
    }
  }
</script>

<style>
    #messageDialog .el-card{margin-bottom: 15px !important;}
    #messageDialog .el-autocomplete {width: 100%;}
    #messageDialog .list-group-item {
        position: relative;
        display: block;
        padding: 10px 15px;
        background-color: #fff;
        border: 1px solid #ddd;
    }
    #messageDialog .classes label.el-form-item__label{width:100%; text-align: left}
    #messageDialog textarea{border-radius: 0;  border-width: 0px; border-bottom-width: 1px}
    #messageDialog .el-upload-list__item .el-icon-close {
          position: absolute;
          top: 5px;
          right: 5px;
          cursor: pointer;
          opacity: .75;
          color: #48576a;
          transform: scale(.7);
      }
    #messageDialog .compose .el-card__header {padding: 0px;border-bottom: 0}
    #messageDialog .el-form-item {margin-bottom: 15px;}
    #rtl #messageDialog h5 {float: left;} 
    #messageDialog h5 {float: right;} 
    #messageDialog .pull-right {float: right;} 
    #rtl #messageDialog .pull-right {float: left;} 
</style>



// WEBPACK FOOTER //
// Message.vue?ac46fd80